/**
 * L'Invoice project translations - Sidebar section
 */

const sidebar = {
  lookUp: "Look up",
  documents: "Documents",
  edocuments: "E-documents",
  customers: "Customers",
  reports: "Reports",
  settings: "Settings",
  integrations: "Integrations",
};

export default sidebar;
